/**
 * Canonical keyboard chord strings (modifier order: Ctrl, Alt, Shift, then key)
 * used by the global key handler and the Shortcut Mapper capture.
 */

const ARROW_ALIASES: Record<string, string> = {
  ArrowUp: "Up",
  ArrowDown: "Down",
  ArrowLeft: "Left",
  ArrowRight: "Right",
};

export function normalizeKeyTokenForChord(key: string): string {
  if (key === " ") return "Space";
  const a = ARROW_ALIASES[key];
  if (a) return a;
  if (key.length === 1) return key.toUpperCase();
  return key;
}

/** Build the same chord label as the app menubar uses for matching key events. */
export function shortcutFromKeyboardEvent(ev: KeyboardEvent): string | null {
  if (["Control", "Shift", "Alt", "Meta"].includes(ev.key)) return null;
  const parts: string[] = [];
  if (ev.ctrlKey || ev.metaKey) parts.push("Ctrl");
  if (ev.altKey) parts.push("Alt");
  if (ev.shiftKey) parts.push("Shift");
  const key = normalizeKeyTokenForChord(ev.key);
  parts.push(key);
  if (parts.length === 1) return parts[0]!;
  const mod = parts.slice(0, -1).join("+");
  const last = parts[parts.length - 1]!;
  return `${mod}+${last}`;
}
